import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { GET, APIImpl } from '../../api';
import { BannerRequest } from './bannerrequest';

export class BannerAPI extends APIImpl<BannerRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/banner
        return "banner"+"?"+"language="+ this.getRequest().getBannerRequest().getLanguage();
    }

    /* getHttpHeaders():string
    {
        return {
            "accessToken": this.getContext().getUserContext().getAccessToken()
        } as any;
    }  */

    getRequestData()
    {
       // return "language="+ this.getRequest().getBannerRequest().getLanguage();
        return "";
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/getbanner/bannerapi.tsx